import type { AxiosResponse } from 'axios';
import routes from '@/config/routes';
import { v3Get, v3Post, v3Remove } from '@/api/axios.instance.V3';
import type { ApiResponse } from '../types';
import type { IGroupPermissionPost, IGroupPermissionDelete } from '@/store/admin/types/types';

const getGroupPermission = (clientId: number, groupId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.permissionAdmin.groupPermission}/client/${clientId}/group/${groupId}/list`);

const saveGroupPermission = async (groupPermission: IGroupPermissionPost): Promise<AxiosResponse> =>
  await v3Post(`${routes.backendUrl.permissionAdmin.groupPermission}/create`, groupPermission);

const deleteGroupPermission = async (groupPermission: IGroupPermissionDelete): Promise<AxiosResponse> =>
  await v3Remove(
    `${routes.backendUrl.permissionAdmin.groupPermission}/delete/${groupPermission.groupId}/${groupPermission.permissionId}`,
  );

export const groupPermissionAdminApi = {
  getGroupPermission,
  saveGroupPermission,
  deleteGroupPermission,
};
